import { render, staticRenderFns } from "./miniTweetsItem.vue?vue&type=template&id=353eff4a&"
import script from "./miniTweetsItem.vue?vue&type=script&lang=js&"
export * from "./miniTweetsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports